var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tvUrl)?_c('a',{staticClass:"wspdsc01-link-button fs-bs",attrs:{"href":_vm.tvUrl,"target":"_blank"}},[_vm._v("Csatornakiosztás")]):_vm._e(),(_vm.isDKTV)?_c('button',{staticClass:"wspdsc01-link-button fs-bs",on:{"click":_vm.openDetailsModal}},[_vm._v("Csatornakiosztás")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{}!./node_modules/pug-plain-loader!./node_modules/vue-loader/lib?{}!../source/modules/WSPP01-product-package/WSPP01-accordion/channels-link-or-modal.vue?vue&type=template&id=148f4f95&lang=pug&
// module id = 1209
// module chunks = 7